import React from 'react';
import ReactDOM from 'react-dom/client';
import FondApp from './FondApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <FondApp />
  </React.StrictMode>
);
